import { 
    Code2, 
    Smartphone, 
    Palette,
    Brain, 
    Shield, 
    Cloud, 
    Megaphone,
    ArrowUpRight,
    Sparkles
  } from "lucide-react";
  import { Button } from "@/components/ui/button";
  import { useNavigate } from "react-router-dom";
  
  export const ServicesGrid = () => {
    const navigate = useNavigate();
    const services = [
      {
        icon: Code2,
        title: "Web Development",
        description: "Fast, scalable web applications with modern frameworks.",
        gradient: "from-blue-500 to-cyan-500",
      },
      {
        icon: Smartphone,
        title: "Mobile Apps",
        description: "Native and cross-platform iOS & Android apps.",
        gradient: "from-purple-500 to-pink-500",
      },
      {
        icon: Palette,
        title: "UI/UX Design",
        description: "User-centered design that converts and delights.",
        gradient: "from-rose-500 to-pink-500",
      },
      {
        icon: Brain,
        title: "AI Solutions",
        description: "Intelligent automation and custom AI models.",
        gradient: "from-violet-500 to-purple-500",
      },
      {
        icon: Shield,
        title: "Cybersecurity",
        description: "Security audits, compliance, and monitoring.",
        gradient: "from-red-500 to-orange-500",
      },
      {
        icon: Cloud,
        title: "Cloud Solutions",
        description: "AWS, Azure, Kubernetes, serverless.",
        gradient: "from-emerald-500 to-teal-500",
      },
      {
        icon: Megaphone,
        title: "Digital Marketing",
        description: "Strategy, campaigns, and growth.",
        gradient: "from-amber-500 to-orange-500",
      },
    ];
  
    return (
      <section id="services" className="py-24 relative px-4 sm:px-6 lg:px-8 xl:px-12">
        {/* Background */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent" />
        
        <div className="container mx-auto relative z-10">
          {/* Section Header */}
          <div className="text-center mb-16 max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass border border-primary/20 mb-6">
              <Sparkles className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium">Our Services</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-6">
              Everything you need to
              <span className="gradient-text block">build and scale</span>
            </h2>
            <p className="text-xl text-muted-foreground">
              Comprehensive solutions designed to accelerate your digital transformation
              and drive sustainable growth.
            </p>
          </div>
  
          {/* Services Grid - clean & minimal */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((service, index) => (
              <div
                key={service.title}
                role="button"
                tabIndex={0}
                className="group relative p-6 rounded-xl glass-card hover-lift cursor-pointer overflow-hidden border border-border/50 hover:border-primary/30 transition-colors"
                style={{ animationDelay: `${index * 0.1}s` }}
                onClick={() => navigate("/services")}
                onKeyDown={(e) => e.key === "Enter" && navigate("/services")}
              >
                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br ${service.gradient} mb-4 group-hover:scale-105 transition-transform`}>
                  <service.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-lg font-heading font-semibold mb-2 flex items-center gap-2">
                  {service.title}
                  <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
  
          {/* CTA */}
          <div className="text-center mt-12">
            <Button size="lg" variant="outline" className="glass border-primary/30 hover:bg-primary/10" onClick={() => navigate("/services")}>
              View All Services
              <ArrowUpRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>
      </section>
    );
  };
  